import { RouteObject } from "react-router-dom";
import { AppsVersions, EditVersionWithoutApk, EditVersionWithApk, UploadVersion, ViewAppVersion } from "../pages";

const AppsVersionsRoutes: RouteObject[] = [
    {
        path: '',
        element: <AppsVersions />,
    },
    {
        path: 'upload',
        element: <UploadVersion />,
    },
    {
        path: ':versionId/edit-with-apk',
        element: <EditVersionWithApk />,
    },
    {
        path: ':versionId/edit',
        element: <EditVersionWithoutApk />,
    },
    {
        path: ':versionId',
        element: <ViewAppVersion />,
    }
]

export default AppsVersionsRoutes;
